<template>
    <div>
        <div v-if="configurationData.hasRouter">
            <already-has-router-info :configuration-data="configurationData" />
        </div>

        <hardware-radio-options
            v-else-if="routers.length > 0"
            v-model="localSelectedRouterId"
            :title="lang('Router','Router')"
            :options="localRouters"
        />
    </div>
</template>

<script>
import AlreadyHasRouterInfo from '../AlreadyHasRouterInfo.vue';
import HardwareRadioOptions from './HardwareRadioOptions.vue';

export default {
    components: { HardwareRadioOptions, AlreadyHasRouterInfo },
    model: {
        prop: 'selected',
        event: 'input',
    },
    props: {
        configurationData: {
            type: Object,
            required: true,
        },
        routers: {
            type: Array,
            required: true,
        },
        selected: {
            type: [Object, null],
            required: false,
            default: null,
        },
        allowNoneSelection: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            localSelectedRouterId: null,
            localRouters: [],
        };
    },
    computed: {
        localSelected: {
            get() {
                return this.selected;
            },
            set(router) {
                this.$emit('input', router);
            },
        },
    },
    watch: {
        localSelectedRouterId(newRouterId) {
            this.localSelected = this.routers.find(router => router.value === newRouterId);
        },
        routers() {
            this.setupRouters();
        },
        allowNoneSelection() {
            this.setupRouters();
        },
    },
    mounted() {
        this.setupRouters();
    },
    methods: {
        setupRouters() {
            this.localRouters = [];

            if (this.routers.length === 0 || this.configurationData.hasRouter) {
                return;
            }

            this.routers.forEach(router => {
                router['name'] = 'router';

                this.localRouters.push(router);
            });

            if (this.allowNoneSelection) {
                this.localRouters.push({
                    value: 'no_router',
                    name: 'router',
                    placeholder: lang('Ingen router','No router'),
                });
            }

            this.localSelectedRouterId = this.getDefaultSelectedRouterId();
        },
        getDefaultSelectedRouterId() {
            const firstRouter = this.localRouters[0];
            if (! this.localSelectedRouterId) {
                return firstRouter.value;
            }

            const selectedRouterIsSelectable = this.localRouters
                .find(router => router.value === this.localSelectedRouterId);

            return selectedRouterIsSelectable ? this.localSelectedRouterId : firstRouter.value;
        },
    },
};
</script>
